import React from "react";
import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import ReferenceData from "../../../../components/admin/referenceData/ReferenceData";

const ReferenceDataManagement = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.nomenclatures.reference.data")}>
      <ReferenceData />
    </PageWrapper>
  );
};

export default ReferenceDataManagement;
